<template lang="pug">
  .layout
    y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px" :fullscreen="$vuetify.breakpoint.xsOnly")
      v-card
        v-card-title.px-5(:style="`background-color: ${$vuetify.theme.themes[$theme].basic600T16}`")
          v-row(no-gutters align="center")
            v-col.shrink
              v-btn.ml-n3(text icon @click="showModal = !showModal")
                v-icon(color="basic800" :size="24") mdi-close
            v-col.ml-3
              p.mb-0.h6.basic800--text Assign Products

        v-card-text.pa-0
          v-container.white(style="max-width:600px")
            v-layout.mt-2
              v-text-field(v-model="searchText" placeholder='Search product' hide-details dense outlined height="40" background-color="basic200")
                template(v-slot:append)
                  eva-icon(name="search-outline" :fill="$vuetify.theme.themes[$theme].basic600")
          
          v-container.px-1(style="max-width:600px")
            v-layout.my-6(v-if="isFetching")
              v-row.fill-height.ma-0(align='center' justify='center')
                v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
            .contain-layout(v-else)
              v-layout.my-6(v-if="products.length == 0")
                v-row.fill-height.ma-0(align='center' justify='center')
                  div.mx-auto
                    v-img.mx-auto(:src="require('@/assets/images/icon_empty.png')" style="width:80px; height:80px" contain)
                    p.caption Products not found or empty
              div(v-else)
                template(v-for="(product, productIndex) in products")
                  v-card(flat @click="clickProduct(product, productIndex)")
                    v-row(no-gutters )
                      v-col.shrink
                        v-img(:src="product.image ? product.image.file : require('@/assets/image_placeholder.png')" width="88px" aspect-ratio="1")
                      v-col.py-2.px-2
                        div.p1.basic800--text.mb-1(v-if="$vuetify.breakpoint.xs") {{ product.name | truncate(27) }}
                        div.p1.basic800--text.mb-1(v-else) {{ product.name | truncate(65) }}
                        div.c1.basic600--text.product-price.mb-1 {{ product.price | displayPrice }}
                        v-chip.c2.primary500--text.my-auto(v-if="product.options.length > 0" x-small style="border: 1px solid var(--v-primary500)") {{ product.options.length === 1 ? 'Variants' : 'Multivariants' }}
                      v-col.pa-2.shrink.d-flex.flex-column.align-center
                        y-checkbox(v-model="product.selected" readonly)
                        v-btn.mr-2(icon @click.stop="product.showSpecsGroup = !product.showSpecsGroup")
                          eva-icon(v-if="product.options.length > 0" :name="product.showSpecsGroup ? 'arrow-ios-upward-outline' : 'arrow-ios-downward-outline'" width="16" height="16" :fill="$vuetify.theme.themes[$theme].primary500")
                  template(v-if="product.options.length > 0 && product.showSpecsGroup")
                    v-divider.basic300.mb-4
                    div.pb-4.px-6(v-for="(parentSpec, parentSpecIndex) in product.specsGroup" :key="parentSpec.id")
                      y-checkbox(v-model="parentSpec.selected" @change="parentSelection(parentSpec, product)")
                        template(v-slot:label)
                          div.p2 {{ parentSpec.value }}
                      template(v-if="parentSpec.child")
                        v-row.pl-6(no-gutters)
                          v-col.my-1(v-for="childSpec in parentSpec.child" :key="childSpec.id" cols="6")
                            y-checkbox(v-model="childSpec.selected" @change="childSelection(parentSpec, product)")
                              template(v-slot:label)
                                div.p2 {{ childSpec.value }}
                        v-divider.basic300.my-2(v-if="parentSpec.child && parentSpecIndex < product.specsGroup.length - 1")

                  v-divider.basic300
                
              div.ma-4
                y-pagination(v-model="page" :pageSize="fetchCount" :count="count")

        v-card-actions
          v-spacer
          v-btn(color='white', text @click='showModal = false')
            .button-Aa-small.primary400--text Cancel
          v-btn.mr-2(color='textColorAccent' depressed height=32  @click="clickDone" :loading="isLoading" dark)
            .button-AA-small.basic100--text Done

</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'AssignProductsBundle',
  props: {
    open: {
      type: Boolean,
      default: false
    },
    excludeProductIds: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    isFetching: false,
    fetchCount: 20,
    page: 1,
    count: 0,
    products: [],
    selectedProducts: [],
    searchText: '',
    searchCountDown: null,
    isLoading: false
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  watch: {
    page(val) {
      if (!this.isFetching) {
        this.fetchProducts(val)
      }
    },
    searchText() {
      if (this.searchCountDown) {
        clearTimeout(this.searchCountDown)
      }
      this.searchCountDown = setTimeout(() => {
        this.searchItem()
      }, 500)
    }
  },
  mounted() {
    this.fetchProducts(1)
  },
  methods: {
    ...mapActions(['showMessage']),
    clickProduct(product, index) {
      const selected = !this.products[index].selected
      this.updateProduct({ product: this.products[index], selected, updateAllSpecs: true })
    },
    updateProduct({ product, selected, updateAllSpecs }) {
      product.selected = selected
      if (selected) {
        this.addProduct({ product, updateAllSpecs })
      } else {
        this.removeProduct({ product, updateAllSpecs })
      }
    },
    // Check for child selection event and enable/disable parent
    childSelection(parentSpec, parentProduct) {
      const hasOneChildSelected = parentSpec.child.some(item => item.selected)
      parentSpec.selected = hasOneChildSelected
      // Check parent product
      const hasOneParentSelected = parentProduct.specsGroup.some(spec => spec.selected)
      // Update if parent product selection changes
      if (hasOneParentSelected !== parentProduct.selected) {
        this.updateProduct({ product: parentProduct, selected: hasOneParentSelected, updateAllSpecs: false })
      }
    },
    // Check for parent selection event and enable/disable child
    parentSelection(parentSpec, parentProduct) {
      const selection = parentSpec.selected
      if (parentSpec.child) {
        parentSpec.child.forEach(item => (item.selected = selection))
      }
      // Check parent product
      const hasOneSelected = parentProduct.specsGroup.some(spec => spec.selected)
      // Update if parent product selection changes
      if (hasOneSelected !== parentProduct.selected) {
        this.updateProduct({ product: parentProduct, selected: hasOneSelected, updateAllSpecs: false })
      }
    },
    addProduct({ product, updateAllSpecs }) {
      if (product.specsGroup && updateAllSpecs) {
        this.updateAllSelectedSpecs({ specsGroup: product.specsGroup, selected: true })
      }
      this.selectedProducts.push(product)
    },
    removeProduct({ product, updateAllSpecs }) {
      if (product.specsGroup && updateAllSpecs) {
        this.updateAllSelectedSpecs({ specsGroup: product.specsGroup, selected: false })
      }
      this.selectedProducts = this.selectedProducts.filter(x => x.id !== product.id)
    },
    updateAllSelectedSpecs({ specsGroup, selected }) {
      specsGroup.forEach(group => {
        group.selected = selected
        if (group.child) {
          this.updateAllSelectedSpecs({ specsGroup: group.child, selected })
        }
      })
    },
    getSelected(product) {
      let selprod = this.selectedProducts.filter(f => f.id === product.id)
      if (selprod.length > 0) {
        return true
      }
      return false
    },
    filterProperties(obj) {
      const allowedProperties = ['id', 'status', 'name', 'price', 'image', 'options', 'variants']
      const filteredObj = this.$options.filters.filterAllowedObjectProperties(obj, allowedProperties)
      // Custom properties
      filteredObj.selected = this.getSelected(obj)
      if (filteredObj.options.length > 0) {
        filteredObj.specsGroup = this.productSpecGrouping(filteredObj.options)
        filteredObj.showSpecsGroup = false
      }
      return filteredObj
    },
    fetchProducts(page) {
      this.page = parseInt(page)
      this.isFetching = true
      let fetchUrl = `/products/?page=${page}&page_size=${this.fetchCount}&company=${this.company.id}&expand=options,variants&exclude_ids=${this.excludeProductIds}&bundle=false&status=published&ordering=-id`
      if (this.searchText) {
        fetchUrl += `&search=${this.searchText}`
      }
      this.$axios
        .get(fetchUrl)
        .then(response => {
          this.isFetching = false
          this.products = response.data.results.map(product => {
            return this.filterProperties(product)
          })
          this.count = response.data.count
        })
        .catch(() => {})
    },
    searchItem() {
      let searchUrl = `/products/?page=1&page_size=${this.fetchCount}&company=${this.company.id}&expand=options,variants&exclude_ids=${this.excludeProductIds}&bundle=false&ordering=-id`
      if (this.searchText) {
        searchUrl += `&search=${this.searchText}`
      }
      this.isFetching = true
      this.page = 1
      this.$axios
        .get(searchUrl)
        .then(response => {
          this.isFetching = false
          this.products = response.data.results.map(product => {
            return this.filterProperties(product)
          })
          this.count = response.data.count
        })
        .catch(() => {})
    },
    productSpecGrouping(options) {
      /** Data Preparation
       * Must be in form of array of array
       * Example
       * [
       *  [
       *    { id: 1, value: 'Black'},
       *    { id: null, value: 'White'}
       *  ],
       *  [
       *    { id: 2, value: 'L' },
       *    { id: 3, value: 'M' },
       *    { id: null, value: 'S'}
       * ], ...]
       *  **/
      const data = []
      options.forEach(option => {
        data.push(
          option.specs.map(spec => {
            return {
              id: spec.id,
              value: spec.value
            }
          })
        )
      })
      // Grouping process
      function assignChildren(parentGroup, childGroup) {
        parentGroup.forEach(parent => {
          if (!parent.child) {
            // Create child for prev group
            const newData = childGroup.map(item => {
              return {
                id: item.id,
                value: item.value,
                selected: false,
                child: null
              }
            })

            parent.child = [...newData]
          } else {
            assignChildren(parent.child, childGroup)
          }
        })
      }
      return data.reduce((acc, group) => {
        // Create first group
        if (acc.length === 0) {
          group.forEach(item => {
            acc.push({
              id: item.id,
              value: item.value,
              selected: false,
              child: null
            })
          })
        } else {
          // Assign nested childrens
          assignChildren(acc, group)
        }
        return acc
      }, [])
    },
    findMatchingVariants({ variants, specs }) {
      /**
       * Construct array of selected specs
       * Example of selected specs
       * White: 1 & XL: 2,
       * White: 1 & L: 3,
       * Black: 2 & XL: 2
       * Return resp will be like this (in sorted order)
       * [[1, 2], [1, 3], [2, 2]]
       */
      function groupSpecs(acc, spec, parentIds) {
        if (spec.selected) {
          if (!spec.child) {
            if (parentIds) {
              acc.push([...parentIds, spec.id].sort())
            } else {
              acc.push([spec.id])
            }
          } else {
            let currentIds = null
            if (parentIds) {
              currentIds = [...parentIds, spec.id]
            } else {
              currentIds = [spec.id]
            }
            spec.child.forEach(child => groupSpecs(acc, child, currentIds))
          }
        }
        return acc
      }
      // Find matched or not and return variant with enabled true/false
      function isMatched(variant, groupedSpec) {
        // Sort variant specs first
        const variantSpecs = variant.specs.sort()
        // Find and filter each groupedSpec based on variant spec
        const found = variantSpecs.reduce((filteredSpecs, spec) => {
          return filteredSpecs.filter(eachSpecs => {
            let resp = false
            if (eachSpecs.includes(spec)) {
              resp = true
            }
            return resp
          })
        }, groupedSpec)
        if (found.length > 0) {
          return { ...variant, enabled: true }
        } else {
          return { ...variant, enabled: false }
        }
      }
      // Grouping and find matching variants
      const groupedSpec = specs.reduce((acc, spec) => {
        return groupSpecs(acc, spec)
      }, [])

      const resp = variants.map(variant => {
        return isMatched(variant, groupedSpec)
      })
      return resp
    },
    clickDone() {
      this.isLoading = true
      const resp = this.selectedProducts.map(selectedProduct => {
        const allowedProperties = ['id', 'name', 'image', 'price', 'options']
        const data = this.$options.filters.filterAllowedObjectProperties(selectedProduct, allowedProperties)
        if (selectedProduct.specsGroup) {
          data.variants = this.findMatchingVariants({ variants: selectedProduct.variants, specs: selectedProduct.specsGroup })
        } else {
          data.variants = []
        }
        return data
      })
      this.$emit('updateData', resp)
      this.showModal = false
    }
  }
}
</script>

<style scoped>
.product-description {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
</style>